import React, {useEffect, useState} from "react";
import {Box, Typography, Divider, TextField} from "@mui/material";
import QRCode from "qrcode";
import GetSupportAccountInfo from "./gql/GetSupportAccountInfo.graphql";
import {useLogin} from "../components/login/LoginProvider";
import {useQuery} from "@apollo/client";

const SupportAccountInfoPage = () => {
  const [qrCodeData, setQrCodeData] = useState();
  const {user} = useLogin();

  const getSupportAccountInfo = useQuery(GetSupportAccountInfo, {
    variables: {username: user?.username},
    skip: !user?.username,
  });

  useEffect(() => {
    if (getSupportAccountInfo.error) {
      console.error(getSupportAccountInfo.error);
    }
  }, [getSupportAccountInfo.error]);

  const supportAccountValues = getSupportAccountInfo?.data?.getSupportAccountInformation;

  useEffect(() => {
    const generateQR = async () => {
      if (!supportAccountValues?.mfa) return;
      const qrData = await QRCode.toDataURL(supportAccountValues.mfa);
      setQrCodeData(qrData);
    };

    generateQR();
  }, [supportAccountValues]);

  return (
    <Box>
      <>
        <Box marginBottom={1}>
          <Typography variant="h4" mb={2}>
            Access Support Account Information
          </Typography>
        </Box>
        <Box mt={2}>
          <Box padding={1}>
            <Typography variant="h5" sx={{marginBottom: 3}}>
              {"Support Role Information"}
            </Typography>
            <Box padding={1}>
              <TextField
                variant="outlined"
                id="supportRoleEmail"
                label="Support Role Email"
                size="small"
                fullWidth={true}
                InputLabelProps={{shrink: true}}
                value={supportAccountValues?.username ?? ""}
                disabled
              />
            </Box>
            <Box padding={1}>
              <TextField
                variant="outlined"
                id="supportRolePassword"
                label="Support Role Password"
                size="small"
                fullWidth={true}
                InputLabelProps={{shrink: true}}
                value={supportAccountValues?.info ?? ""}
                disabled
              />
            </Box>
            <Divider sx={{borderWidth: 2, marginY: 2}} />
            <Typography variant="h5" sx={{marginBottom: 3}}>
              Multifactor Authentication Information
            </Typography>
            <Box padding={1}>
              <TextField
                variant="outlined"
                id="MfaKey"
                label="MFA Key"
                size="small"
                fullWidth={true}
                InputLabelProps={{shrink: true}}
                value={supportAccountValues?.mfa ?? ""}
                disabled
              />
            </Box>
            <Box>
              {qrCodeData && (
                <Box padding={1}>
                  <Typography variant="h7" sx={{display: "block"}}>
                    Or scan the MFA QR code below
                  </Typography>
                  <img src={qrCodeData} alt="QR Code" />
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </>
    </Box>
  );
};

export default SupportAccountInfoPage;
